var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStorefront = function SvgStorefront(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 16.45a1 1 0 0 1 1 1V26h18v-8.55a1 1 0 1 1 2 0V26a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8.55a1 1 0 0 1 1-1M6.75 4h18.508a2.01 2.01 0 0 1 1.913 1.441l.003.01 1.788 6.275A1 1 0 0 1 28 13H4a1 1 0 0 1-.962-1.274l1.79-6.285A2.01 2.01 0 0 1 6.743 4zm.007 2a.01.01 0 0 0-.01.008L5.325 11h21.35l-1.422-4.992-.004-.006L25.243 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11a1 1 0 0 1 1 1v2a3 3 0 0 0 6 0v-2a1 1 0 1 1 2 0v2a5 5 0 1 1-10 0v-2a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11a1 1 0 0 1 1 1v2a3 3 0 0 0 6 0v-2a1 1 0 1 1 2 0v2a5 5 0 1 1-10 0v-2a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11a1 1 0 0 1 1 1v2a3 3 0 0 0 6 0v-2a1 1 0 1 1 2 0v2a5 5 0 1 1-10 0v-2a1 1 0 0 1 1-1"
  }))));
};
export default SvgStorefront;